import * as actionTypes from "../actionTypes/Index";
import { storeListingInitilState } from "./InitialState";
import { IActionType } from "../../interfaces/Index";

const initialState = { ...storeListingInitilState };

export default function storeListingReducer(
  state = initialState,
  action: IActionType
) {
  switch (action.type) {
    case actionTypes.BULK_UPLOAD_INIT: {
      return Object.assign({}, state, {
        isLoading: false,
        isStoreListingBulkUploading: true,
        isStoreListingBulkUploadingError: false,
        isStoreListingBulkUploaded: false,
        isStoreListingDetailsFetched: false,
        error: null,
      });
    }
    case actionTypes.BULK_UPLOAD_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isStoreListingBulkUploading: false,
        isStoreListingBulkUploaded: true,
      });
    }
    case actionTypes.BULK_UPLOAD_FAIL: {
      return Object.assign({}, state, {
        isStoreListingBulkUploading: false,
        isStoreListingBulkUploadingError: true,
        isStoreListingBulkUploaded: false,
        error: action.error,
      });
    }
    default:
      return state;
  }
}
